import { render, staticRenderFns } from "./InsightProjectLink.vue?vue&type=template&id=ffdc504a"
import script from "./InsightProjectLink.vue?vue&type=script&lang=js"
export * from "./InsightProjectLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports